import { SideMenuComponent } from './side-menu/side-menu.component';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NavBarComponent } from './nav-bar/nav-bar.component';
import { AppMaterialModule } from 'src/app/app-material.module';
import { RouterModule } from '@angular/router';
import { NgxMaskModule } from 'ngx-mask';
import { GenericBottomSheetComponent } from './generic-bottom-sheet/generic-bottom-sheet.component';
import { SelectBankAccountComponent } from 'src/app/pages/orders/inbound/components/modals/select-bank-account/select-bank-account.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

@NgModule({
  declarations: [
    SideMenuComponent,
    GenericBottomSheetComponent,
    NavBarComponent,
    SelectBankAccountComponent,
  ],
  imports: [
    CommonModule,
    AppMaterialModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule,
    NgxMaskModule.forChild(),
  ],
  exports: [
    SideMenuComponent,
    NavBarComponent,
    SelectBankAccountComponent,
    GenericBottomSheetComponent,
    AppMaterialModule,
  ],
})
export class SharedComponentsModule {}
